<template>
  <div>
    <jodit-editor v-model="editorContent" :setConfigs="setConfigs" />
<!--    <jodit-vue v-model="editorContent" :config="configs" :buttons="buttons"/>-->
  </div>
</template>

<script>
export default {
  name: 'jodit_editor',
  props: {
    content: {
      type: String,
      required: true
    },
    minHeight: {
      type: Number,
      required: true
    },
    height: {
      type: Number,
      required: true
    },
    updateContent: {
      type: Function,
      required: true
    },
    editorConfig: {
      type: Object,
      required: false
    }
  },
  watch: {
    content () {
      this.editorContent = this.content
    },
    editorContent () {
      this.updateContent(this.editorContent)
    }
  },
  created () {
    if (this.editorConfig) {
      this.setConfigs.configs.askBeforePasteFromWord = this.editorConfig.askBeforePasteFromWord
      this.setConfigs.configs.askBeforePasteHTML = this.editorConfig.askBeforePasteHTML
      this.setConfigs.configs.defaultActionOnPaste = this.editorConfig.defaultActionOnPaste
    }
  },
  mounted () {
    this.editorContent = this.content
  },
  data () {
    return {
      setConfigs: {
        buttons: ['bold', 'strikethrough', 'underline', 'italic', 'paragraph', 'font', 'fontsize', 'brush', '|', 'ul', 'align', 'outdent', 'indent', 'hr', '|', 'image', 'link'],
        configs: {
          imageDefaultWidth: 550,
          minHeight: this.minHeight,
          height: this.height,
          toolbarButtonSize: 'small',
          showCharsCounter: false,
          i18n: {
            ko: {
              'Type something': 'メッセージを入力してください。',
              'Bold': '太く'
            }
          },
          link: {
            followOnDblClick: false
          }
        }
      },
      editorContent: ''
    }
  },
  methods: {
    getHtml () {
      return this.editorContent
    },
    setHtml (str) {
      this.editorContent = str
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/jodit_editor.vue